import React from 'react';

import camelize from 'lodash/camelCase';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { parseVideoIdInput } from '~/shared/utils/assetHelper';
import goToAnchor from '~/shared/utils/goToAnchor';
import usePromoTracking from '~/shared/utils/usePromoTracking';
import { ImageAsset } from '~/techstyle-shared/react-assets';
import { Video, withThemeProps } from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

const DynamicFormattedMessage = FormattedMessage;

const Card = styled.div`
  ${({ card }) => card};
  cursor: pointer;
`;

const CardTitle = styled.div`
  ${({ theme }) => theme.typography.values.heading3small};

  ${({ cardTitle }) => cardTitle};
`;

const CardBody = styled.div`
  ${({ cardBody }) => cardBody};
`;

const CardImage = styled(ImageAsset)`
  ${({ cardImage }) => cardImage};
  width: 100%;
`;

const VideoWrapperStyle = css`
  width: 100%;
`;

const CardSubtitle = styled.div`
  ${({ cardSubtitle }) => cardSubtitle};
`;

const DefaultMarketingCard = ({ asset, index, refs, ...rest }) => {
  const { triggerPromoTracking } = usePromoTracking();

  const handlePromoClicked = () => {
    triggerPromoTracking(asset);
  };

  const {
    link = '',
    title = '',
    subtitle = '',
    anchorTo = null,
  } = asset?.options?.customVars;
  // check for a video id

  const { videoId, videoAspectRatio } = parseVideoIdInput({ asset });
  return (
    <Card index={index} onClick={() => goToAnchor(refs, anchorTo)} {...rest}>
      {videoId ? (
        <Video
          aspectRatio={videoAspectRatio}
          url={Video.getUrlFromVideoId(videoId)}
          wrapperStyle={VideoWrapperStyle}
        />
      ) : (
        <CardImage asset={asset} onClick={handlePromoClicked} {...rest} />
      )}

      <CardBody {...rest}>
        {title && (
          <CardTitle {...rest}>
            {link ? (
              <a href={link} onClick={handlePromoClicked}>
                <DynamicFormattedMessage
                  id={`Marketing_card.asset_card_title-${camelize(title)}`}
                  defaultMessage={title}
                />
              </a>
            ) : (
              <DynamicFormattedMessage
                id={`Marketing_card.asset_card_title-${camelize(title)}`}
                defaultMessage={title}
              />
            )}
          </CardTitle>
        )}
        {subtitle && (
          <CardSubtitle {...rest}>
            <DynamicFormattedMessage
              id={`Marketing_card.asset_card_subtitle-${camelize(title)}`}
              defaultMessage={subtitle}
            />
          </CardSubtitle>
        )}
      </CardBody>
    </Card>
  );
};

DefaultMarketingCard.propTypes = {
  asset: PropTypes.object,
  index: PropTypes.number,
  refs: PropTypes.object,
};

export default withThemeProps(DefaultMarketingCard, {
  section: 'marketingCard',
  defaultVariant: 'default',
});
